import { FC } from "react"
import { useTranslation } from "react-i18next"
import { Icon } from "Components/UI"
import { Card, CardItem, Container, Hr } from "./styles"

interface IMoreActionsDropdownContentProps {
  preferencesFeature?: boolean;
  record: any | null
  apiText: string
  onToggleFollow: (ids: number[]) => void
  onEdit: (discipline: any) => void
  onOpenSA: () => void
  onOpenHistoryDrawer: (record?: any | null) => void
  onOpenModalExclusao: (
    id: number,
    name: string,
    icon: string,
    folderId: string
  ) => void
}

const MoreActionsDropdownContent: FC<IMoreActionsDropdownContentProps> = ({
  preferencesFeature,
  record,
  apiText,
  onToggleFollow,
  onEdit,
  onOpenSA,
  onOpenHistoryDrawer,
  onOpenModalExclusao,
}) => {
  const { t } = useTranslation('disciplinas');

  return (
    <Container>
      {preferencesFeature && (
        <>
          <Card>
            {record?.IsFollow ? (
              <CardItem onClick={() => onToggleFollow([record.ConstructionSiteDisciplinesId])}>
                <Icon icon="eyeX" customSize={18} className="cardItemIcon" />
                <span className="cardItemText">
                  {t('moreActions.unfollow')}
                </span>
              </CardItem>
            ) : (
              <CardItem onClick={() => onToggleFollow([record.ConstructionSiteDisciplinesId])}>
                <Icon icon="visualizar" customSize={10} className="cardItemIcon" />
                <span className="cardItemText">
                  {t('moreActions.follow')}
                </span>
              </CardItem>
            )}
          </Card>
          <Hr />
        </>
      )}
      <Card>
        <CardItem onClick={() => onEdit(record)}>
          <Icon icon="newEdit" customSize={18} className="cardItemIcon" />
          <span className="cardItemText">
            {t('moreActions.editDiscipline')}
          </span>
        </CardItem>
        <CardItem onClick={onOpenSA}>
          <Icon icon="download" customSize={14} className="cardItemIcon" />
          <span className="cardItemText">
            {apiText}
          </span>
        </CardItem>
      </Card>
      <Hr />
      <Card>
        <CardItem onClick={() => onOpenModalExclusao(
          record.ConstructionSiteDisciplinesId,
          record.CustomName || record.Discipline.Name,
          record.Discipline.Icon,
          record.DisciplineApiFolderId
        )}>
          <Icon icon="excluir" customSize={14} className="cardItemIcon" />
          <span className="cardItemText">
            {t('moreActions.delete')}
          </span>
        </CardItem>
      </Card>
    </Container>
  )
}

export default MoreActionsDropdownContent
